<template>
  <div class="footers">
    <router-link :to="{ name: 'Home' }" class="homes" :class="{'active': active * 1 === 1}">首页</router-link>
    <router-link :to="{ name: 'OrderHome' }" class="order" :class="{'active': active * 1 === 2}">订单</router-link>
    <router-link :to="{ name: 'MyHome' }" class="my" :class="{'active': active * 1 === 3}">我的</router-link>
  </div>
</template>
<script>
export default {
  name: 'footers',
  props: {
    active: undefined
  },
  data () {
    return {}
  }
}
</script>
<style scope>
.footers{
  width:100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background:rgba(255,255,255,1);
  box-shadow:0px -2px 2px 0px rgba(0,0,0,0.05);
  padding: 12px 0 8px 0;
  display: flex;
}
.footers a{
  text-decoration: none;
  flex: 1;
  text-align: center;
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  padding-top: 18px;
  position: relative;
}
.footers a::after{
  content: "";
  width: 16px;
  height: 16px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 18px;
  right: 0;
  margin: auto;
}
.footers a.active{
  color: #B2D500;
}
.footers a.homes::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79cf0c8cc20.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
.footers a.active.homes::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79d0b1caac5.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
.footers a.order::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79cf0c97b7a.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
.footers a.active.order::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79d0b1c867c.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
.footers a.my::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79cf0c90c77.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
.footers a.active.my::after{
  background: url('https://img01.wanfangche.com/public/upload/202003/24/5e79d0b1d1f23.png?x-oss-process=style/middle') no-repeat;
  background-size: 100% 100%;
}
</style>
